import { t } from 'i18next';
import { isEmpty } from 'lodash';

import { isEmptyArray } from 'core/utils';
import { IRequestType } from 'support/types';

import { addDays } from 'coreOld/utils';

/**
 * Validate the requested date will return true if the requested date
 * is at least 2 days from today.
 */
export const validateRequestedDate = (dateString: string) => {
  const requestedDate = new Date(dateString);

  requestedDate.setHours(0, 0, 0, 0);

  return requestedDate >= addDays(2);
};

export const getRequestTypeChoices = (requestTypes: IRequestType[]) => {
  if (isEmptyArray(requestTypes)) {
    return [];
  }

  return [
    {
      label: t('labelSupportRequestDefaultType'),
      value: -1,
    },
    ...requestTypes.map((type) => {
      const label = isEmpty(type.levelName) ? type.name : `${type.name} (${type.levelName})`;

      return {
        label: label,
        value: type.id,
        levelId: type.levelId,
        levelName: type.levelName,
      };
    }),
  ];
};
